module.exports = __webpack_public_path__ + "static/media/editor.a9dfb8d0.png";